import { IS_SSR } from 'src/utils/helpers.utils';

export const useDevicePixelRatio = (): number => IS_SSR ? 1 : window.devicePixelRatio ?? 1;